import React from 'react';
import PropTypes from 'prop-types';
import Icon from 'components/icon';
import { useSpring } from 'react-spring';
import { Container, CloseButton } from './style';

const Sticky = ({ backgroundColor, color, children, onClose }) => {
  const wrapperAnim = useSpring({
    opacity: '1',
    from: { opacity: '0.1' },
    config: { duration: 250 },
  });
  return (
    <Container style={wrapperAnim} backgroundcolor={backgroundColor} color={color}>
      <CloseButton color={color} onClick={onClose}>
        <Icon icon='close' size={10} />
      </CloseButton>
      {children}
    </Container>
  );
};

Sticky.propTypes = {
  backgroundColor: PropTypes.string,
  color: PropTypes.string,
  children: PropTypes.node.isRequired,
  onClose: PropTypes.func,
};

Sticky.defaultProps = {
  backgroundColor: null,
  color: null,
  onClose: () => {},
};

export default Sticky;
